const HtmlTab = ({ html }) => {

    return (

        <div
            className="product-html"
            dangerouslySetInnerHTML={{
                __html: html
            }}
        />

    );

};

export default HtmlTab;